import React, {} from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Example } from 'components';
import i18n from 'i18next';

const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: stretch;
	gap: 20px;
`;

const ExmapleBlockCountry = () => {
	const { t } = useTranslation();

	return (
		<>

			<Container>

				<Example url={'https://images.acase.ru/sjas/xmlgw/xsd/CountryActionDescriptionRequest.xsd'} title={t('Схема запроса') + ' ' + t('Информация о стране')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/xsd/CountryActionDescriptionResponse.xsd'} title={t('Схема ответа') + ' ' + t('Информация о стране')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/xsd/CountryActionPubliclistRequest.xsd'} title={t('Схема запроса') + ' ' + t('Список стран')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/xsd/CountryActionPubliclistResponse.xsd'} title={t('Схема ответа') + ' ' + t('Список стран')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/CountryActionDescriptionRequest.xml'} title={t('Пример запроса') + ' ' + t('Информация о стране')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/CountryActionDescriptionResponse.xml'} title={t('Пример успешного ответа') + ' ' + t('Информация о стране')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/CountryActionPubliclistRequest.xml'} title={t('Пример запроса') + ' ' + t('Список стран')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/CountryActionPubliclistResponse.xml'} title={t('Пример успешного ответа') + ' ' + t('Список стран')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/CountryActionDescriptionResponseError.xml'} title={t('Пример ответа с ошибкой')}/>

			</Container>
		</>
	);
};

export default ExmapleBlockCountry;